export const SET_CATEGORY_TEMPLATE = '@@category-price/SET_CATEGORY_TEMPLATE';
export const SET_PRICE_TEMPLATE_TITLE = '@@category-price/SET_PRICE_TEMPLATE_TITLE';
export const SET_PRICES_OF_TEMPLATE = '@@category-price/SET_PRICES_OF_TEMPLATE';
export const SET_ID_CHOOSEN_TEMPLATE = '@@category-price/SET_ID_CHOOSEN_TEMPLATE';
export const SET_TYPE_OF_BUTTON = '@@category-price/SET_TYPE_OF_BUTTON';
export const SET_TEMPLATE = '@@category-price/SET_TEMPLATE';